import type { TFunction } from 'i18next';
import * as yup from 'yup';

import { Refinement } from '@/api/generated';

interface RefinementModalFormData {
  options: string[];
}

const createMinTransformer =
  (min: number, t: TFunction) => (schema: yup.ArraySchema<string[], yup.AnyObject, '', ''>) =>
    schema.min(min, t('validation:atLeastOneValue'));

const createMaxTransformer =
  (max: number, t: TFunction) => (schema: yup.ArraySchema<string[], yup.AnyObject, '', ''>) =>
    schema.max(
      max,
      t('validation:limits.maximum', {
        field: 'options',
        count: max,
        unit: t('validation:unit.none')
      })
    );

export const getRefinementSchema = (refinement: Refinement, t: TFunction) => {
  const { minimumOptions, maximumOptions } = refinement;
  const baseSchema = yup.array().of(yup.string().required()).required();

  const optionsSchema = [
    minimumOptions != null && createMinTransformer(minimumOptions, t),
    maximumOptions != null && createMaxTransformer(maximumOptions, t)
  ]
    .filter(requirement => requirement !== false)
    .reduce((acc, requirement) => requirement?.(acc) ?? acc, baseSchema);

  return yup.object<RefinementModalFormData>().shape({
    options: optionsSchema.required()
  });
};
